import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b5b71374"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card card-container" }
const _hoisted_2 = { class: "form-group column q-gutter-md" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_select = _resolveComponent("q-select")!
  const _component_q_input = _resolveComponent("q-input")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_form = _resolveComponent("q-form")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_q_form, {
        onSubmit: _ctx.handleActivate,
        class: "q-gutter-md"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_q_select, {
            modelValue: _ctx.licenseType,
            "onUpdate:modelValue": [
              _cache[0] || (_cache[0] = ($event: any) => ((_ctx.licenseType) = $event)),
              _ctx.onLicenseTypeChange
            ],
            options: _ctx.licenseOptions,
            label: _ctx.t('activate.licensetype'),
            "emit-value": "",
            "map-options": "",
            rules: [val => val !== null || _ctx.t('activate.selectlicensetype')]
          }, null, 8, ["modelValue", "options", "label", "onUpdate:modelValue", "rules"]),
          _createVNode(_component_q_input, {
            modelValue: _ctx.licenseCode,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.licenseCode) = $event)),
            label: _ctx.t('activate.activationcode'),
            outlined: "",
            mask: "XXXX-XXXX-XXXX-XXXX",
            "input-class": "text-uppercase",
            "lazy-rules": "",
            rules: [
                        val => !!val || _ctx.t('activate.enteractivationcode'),
                        val => _ctx.fullLicenseRegex.test(val) || _ctx.t('activate.invalidcode')
                    ],
            hint: "XXXX-XXXX-XXXX-XXXX"
          }, null, 8, ["modelValue", "label", "rules"]),
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_q_btn, {
              label: _ctx.t('activate.activate'),
              class: "full-width",
              size: "lg",
              type: "submit",
              color: "primary",
              loading: _ctx.loading,
              disable: _ctx.loading
            }, null, 8, ["label", "loading", "disable"]),
            _createVNode(_component_q_btn, {
              label: _ctx.t('activate.deactivate'),
              class: "full-width",
              size: "lg",
              color: "negative",
              loading: _ctx.loading,
              disable: _ctx.loading,
              onClick: _ctx.handleDeactivate
            }, null, 8, ["label", "loading", "disable", "onClick"])
          ])
        ]),
        _: 1
      }, 8, ["onSubmit"]),
      (_ctx.message)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass(["alert", _ctx.successful ? 'alert-success' : 'alert-danger'])
          }, _toDisplayString(_ctx.message), 3))
        : _createCommentVNode("", true)
    ])
  ]))
}